import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import DOMPurify from 'dompurify';
import { v4 as uuidv4 } from 'uuid';

import cashIcon from '../../../../assets/images/CashIcon.svg';
import QuillEditor from '../../../../components/shared/QuillEditor/QuillEditor';
import RewardTemplateDetail from '../../../../components/shared/RewardTemplateDetail/RewardTemplateDetail';
import { CURRENCIES } from '../../../../constants/currenciesConstants';
import { getOrdinalSuffix } from '../../../../helpers/commonHelper';
import { selectCurrentUser } from '../../../../selectors/authSelectors';
import ReferralRewardHeading from '../ReferralRewardBadge/ReferralRewardHeading';

import styles from './OpeningReferralRewards.module.scss';

const OpeningReferralRewards = ({
  rewards = {},
  eligibileForRewards,
  externalTcs,
  showPublicRewards = false,
}) => {
  const { t } = useTranslation('common');
  const user = useSelector(selectCurrentUser);
  const [isCollapsed, setIsCollapsed] = useState(
    !eligibileForRewards && !(showPublicRewards && !user),
  );

  const sanitizedData = DOMPurify.sanitize(externalTcs);
  const cashRewardWithCurrency = (cashRewardDetail) =>
    `${CURRENCIES[cashRewardDetail?.currency_name]}${cashRewardDetail.reward_value}`;

  const handleToggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className={classNames(styles.whiteContainer, { [styles.pb12]: !sanitizedData })}>
      <ReferralRewardHeading
        eligibileForRewards={eligibileForRewards}
        showIcon={false}
        user={user}
        isCollapsed={isCollapsed}
        onToggleCollapse={handleToggleCollapse}
        showToggleButton={!eligibileForRewards}
      />
      {!isCollapsed && (
        <>
          {rewards.map((singleReward) => (
            <div className={styles.rewardList} key={uuidv4()}>
              {singleReward.map((reward, index) => (
                <div className={styles.installmentContainer} key={uuidv4()}>
                  <span className={styles.InstallmentHeading}>
                    {reward.guarantee_period} • {t('browse.installment', { ordinal: getOrdinalSuffix(index + 1) })}
                  </span>
                  {reward.experiential_rewards_attributes?.map((exper_reward) => (
                    <div className={styles.rewardContainer} key={uuidv4()}>
                      <RewardTemplateDetail
                        icon={exper_reward.image}
                        title={exper_reward.name}
                        text={exper_reward.description}
                      />
                    </div>
                  ))}

                  <div>
                    {reward?.monetary_reward_attributes && (
                      <div className={styles.rewardContainer}>
                        <RewardTemplateDetail
                          icon={cashIcon}
                          title={cashRewardWithCurrency(reward?.monetary_reward_attributes)}
                          text={t('buttons.cash')}
                        />
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ))}
          {sanitizedData ? (
            <div className={styles.descriptionContainer}>
              <div className={styles.InstallmentText}>
                <QuillEditor value={sanitizedData} readOnly modules={{ toolbar: false }} />
              </div>
            </div>
          ) : null}
        </>
      )}
    </div>
  );
};

export default OpeningReferralRewards;
